module.exports = __webpack_public_path__ + "img/image_home_02.79969349.svg";